module.exports = __webpack_public_path__ + "static/media/Rodrigo.86e24638.png";